/* SchemaForm TextArea field component */
import React, { useEffect } from "react";
import { Field } from "formik";
import BaseField from "components/util/schema_form/fields/BaseField";
import TextImprovement from "components/util/schema_form/fields/TextImprovement";
import l from "components/util/l";

const TextAreaField = ({
	name,
	label,
	value,
	values,
	defaultValue,
	rows = 5,
	required,
	disabled,
	caption,
	helpMessage,
	placeholder,
	improvementPrompt,
	flowId,
	enableComments,
	setFieldValue
}) => {

	useEffect(() => {
		// Init default value if not defined
		if (value === undefined && defaultValue != null)
			setFieldValue(name, l(defaultValue))
	}, [value, defaultValue])

	return (
		<BaseField
			name={name}
			label={label}
			values={values}
			required={required}
			caption={caption}
			helpMessage={helpMessage}
			enableComments={enableComments}
			setFieldValue={setFieldValue}
		>
			<TextImprovement
				disabled={disabled}
				flowId={flowId}
				improvementPrompt={improvementPrompt}
				name={name}
				setFieldValue={setFieldValue}
				value={value}
			>
				<Field
					as="textarea"
					name={name}
					id={name}
					rows={rows}
					disabled={disabled}
					className={"form-control"}
					onKeyDown={e => e.key === 'Enter' && setFieldValue(name, e.target.value + "\n")}
					placeholder={l(placeholder)}
					required={required}
				/>
			</TextImprovement>
		</BaseField>
	)
}

export default TextAreaField;
